import { isAnyOf } from '@reduxjs/toolkit';

import { env } from '@/config/env';
import { startAppListening } from '@/stores/listener-middleware';

import { patchProjectFile } from '../project/project.thunks';

import { alert, dismissAlert } from '@nablax/shared/stores';
import { selectPendingSyncAsArray } from './sync.selectors';
import { loadApplySync } from './sync.thunks';

let SYNC_TIMER: ReturnType<typeof setTimeout> | null = null;
const SYNC_ERROR_ALERT_KEY = 'syncErrorAlert';

startAppListening({
  // each time a file project is patched cancel last timer
  // and start a timer to sync all pending files to backend
  predicate: isAnyOf(
    patchProjectFile.fulfilled,
    // this implements also a retry mechanism if previous sync failed
    loadApplySync.rejected,
  ),
  effect: (action, api) => {
    const { payload } = action;

    if (!payload) {
      return;
    }

    clearTimeout(SYNC_TIMER!);
    SYNC_TIMER = setTimeout(() => {
      const state = api.getState();
      const pendings = selectPendingSyncAsArray(state);

      // dispatch sync only if there're something to save
      if (pendings.length > 0) {
        api.dispatch(loadApplySync());
      }
    }, env.VITE_SYNC_INTERVAL_MS);
  },
});

startAppListening({
  // each time the sync is applied
  // ensure the timer is reset so when forcing sync
  // it does not trigger multiple times
  actionCreator: loadApplySync.pending,
  effect: () => {
    clearTimeout(SYNC_TIMER!);
  },
});

// on sync failed trigger a fixed alert
// that will be removed on next sync success
startAppListening({
  actionCreator: loadApplySync.rejected,
  effect: (_, { dispatch }) => {
    dispatch(
      alert({
        id: SYNC_ERROR_ALERT_KEY,
        variant: 'warning',
        title: 'alerts.warning',
        message: 'alerts.syncOutdated',
        fixed: true,
      }),
    );
  },
});

// ensure sync error banner is dismissed
// on sync apply success
startAppListening({
  actionCreator: loadApplySync.fulfilled,
  effect: (_, { dispatch }) => {
    dispatch(
      dismissAlert({
        id: SYNC_ERROR_ALERT_KEY,
      }),
    );
  },
});
